/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import * as React from "react";
import {treeFavEnabled, useReadWriteFavorites} from "../../../api/helper";
import {ArgosFavoriteBorderIcon, ArgosFavoriteIcon} from "./ArgosFavoriteIcon";
import Delayed from "../Delayed";
import {Nullable} from "../../../utils/globalTypeUtils";

interface IProps {
  favoriteType: Nullable<string>
  trackedItemUid: Nullable<string>
  isLoading?: boolean
  partitionKey: Nullable<string>
}

export const ArgosFavoriteIconLogic = (props: IProps) => {
  const [favorites, setFavorites] = useReadWriteFavorites()
  const {favoriteType, trackedItemUid} = props

  const _isFavEnabledd = treeFavEnabled(favorites, trackedItemUid)
  const favoriteMethod = _isFavEnabledd ? 'DELETE' : 'POST'

  const setfav = () => {
    setFavorites({type: favoriteType, id: trackedItemUid, partitionKey: props.partitionKey}, favoriteMethod)
  }
  return (
    <Delayed waitBeforeShow={0}>
      {
        props?.isLoading ? <></> :
          _isFavEnabledd ?
            <ArgosFavoriteIcon
              onClick={(e: any) => favoriteIconProps.onClick(e, setfav)}
              onMouseDown={(e: any) => favoriteIconProps.onMouseDown(e)}
            /> :
            <ArgosFavoriteBorderIcon
              onClick={(e: any) => favoriteIconProps.onClick(e, setfav)}
              onMouseDown={(e: any) => favoriteIconProps.onMouseDown(e)}
            />}
    </Delayed>
  )
}
const onClickFavoriteIcon = (e: any, setFavorites: () => void) => {
  e.stopPropagation()
  setFavorites()
}
const onMouseDownFavoriteIcon = (e: any) => {
  e.stopPropagation()
}

const favoriteIconProps = {
  onClick: onClickFavoriteIcon,
  onMouseDown: onMouseDownFavoriteIcon
}